"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPAND_COLUMN = void 0;
var EXPAND_COLUMN = {};
exports.EXPAND_COLUMN = EXPAND_COLUMN;


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/lib/constant.js
// module id = 1082
// module chunks = 0